
import React from "react";

interface EmptyStateProps {
  searchQuery?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ searchQuery }) => {
  return (
    <div className="text-center py-20">
      <h3 className="text-xl font-medium mb-2">No prompts found</h3>
      <p className="text-muted-foreground">
        {searchQuery 
          ? "Try adjusting your search terms or category filters."
          : "No prompts match the current filters."}
      </p>
    </div>
  );
};

export default EmptyState;
